export default function SeatmapTokenService(
    $http,
    $q,
) {
    'ngInject';
    const tokenUrl = '/flights/GetSeatMapToken';

    return {
        getSeatmapToken,
        refreshToken,
    };

    function getSeatmapToken() {
        if (this.token) {
            const deferred = $q.defer();
            deferred.resolve(this.token);

            return deferred.promise;
        }
        return $http.apiGET(tokenUrl).then((response) => {
            this.token = response.data;
            return response.data;
        });
    }

    function refreshToken() {
        return $http.apiGET(tokenUrl).then((response) => {
            this.token = response.data;
            return response.data;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-seatmap/seatmap-token-service.js